
import axios from "axios";
import httpService from "../../services/http.service";
import Config from '../../config.json'
// import TaskService from "./TaskService";
const instance = axios.create({
    timeout:60000,
    headers:{
        'Connection': 'keep-alive'
    }
});
class NotificationAPI{
    api=Config.backend_aws_server_url
    Trigger(data){
        return new Promise((resolve,reject)=>{
            let config = {
                Type: 'Create',
                method: 'post',
                url: this.api+"cloudScaleNotificaionDb/create", 
                // url: "http://127.0.0.1:4000/"+"cloudScaleNotificaionDb/create",
                headers:{},
                data:data
               
            }
            httpService.post('catalyApi/chat', {config:config})
                .then(async(result) => {
                    resolve(result.data);
                })
                .catch((err) => {
                    reject(`${err}`);
                })
        })
    }

    CreateReminder(data){
        return new Promise((resolve,reject)=>{
            let config = {
                Type: 'Create',
                method: 'post',
                url: this.api+"cloudScaleNotificaionDb/reminder/create",
                // url: "http://127.0.0.1:4000/"+"cloudScaleNotificaionDb/reminder/create",
                headers:{},
                data:data
               
            }
            httpService.post('catalyApi/chat', {config:config})
                .then(async(result) => {
                    resolve(result.data);
                })
                .catch((err) => {
                    reject(`${err}`);
                })
        })
    }

    GetTaskReminderNotification(taskid){
        return new Promise((resolve,reject)=>{
            let config = {
                Type: 'Get',
                method: 'Get',
                url: this.api+`cloudScaleNotificaionDb/task/${taskid}/reminder`,
                headers:{}
               
            }
            httpService.post('catalyApi/chat', {config:config})
                .then(async(result) => {
                    resolve(result.data);
                })
                .catch((err) => {
                    reject(`${err}`);
                })
        })
    }

    LiveNotificationLongPollApi(notificationCount){
        return new Promise((resolve,reject)=>{
            instance.get(Config.backend_url+"long-polling?count="+notificationCount)
                .then(async(result) => {
                    resolve(result.data);
                })
                .catch((err) => {
                    reject(`${err}`);
                })
        })
    }
    AllNotificationApi(){
        return new Promise((resolve,reject)=>{
            instance.get(Config.backend_aws_server_url+"CloudScaleDb/getAllNotifications")
                .then(async(result) => {
                    resolve(result.data);
                })
                .catch((err) => {
                    reject(`${err}`);
                })
        })
    }

    GetAllNotifications(){
        return new Promise((resolve,reject)=>{
            let config = {
                Type: 'Get',
                method: 'Get',
                url: this.api+`cloudScaleNotificaionDb/all`,
                headers:{}
               
            }
            httpService.post('catalyApi/chat', {config:config})
                .then(async(result) => {
                    resolve(result.data);
                })
                .catch((err) => {
                    reject(`${err}`);
                })
        })
    }

    UpdateNotification(data){
        return new Promise((resolve,reject)=>{
            let config = {
                Type: 'Update',
                method: 'put',
                url: this.api+"cloudScaleNotificaionDb/update/"+data.ROWID,
                headers:{},
                data:data
               
            }
            httpService.post('catalyApi/chat', {config:config})
                .then(async (result) => {
                    resolve(result)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    }

    SaveAppliedNotificationFilters(filterObj){
        return new Promise((resolve,reject)=>{
            let config = {
                type: 'POST',
                data: filterObj,
                module: "Notification"
            }
            axios.post('', {config:config})
            .then(async (result) => {
                resolve(result)
            })
            .catch((err) => {
                reject(err)
            })
        })
    }
}


export default new NotificationAPI();